<template>
  <div>
    <div>
      <el-form size="small" label-width="100px" :inline="true" class="margin15-t" @submit.native.prevent>
        <el-row :gutter="24">
          <el-col :span="18">
            <el-button icon="el-icon-circle-plus-outline" type="primary" size="small" @click="addTemplateFiledButton()">添加信息字段</el-button>
          </el-col>
          <el-col :span="6" style="float:right">
            <el-form-item>
              <el-select v-model="type" style="width: 100%;" placeholder="请选择" clearable  filterable>
                  <el-option
                    v-for="item in typeOperate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getData(1)"><i class="fa fa-search"></i>搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="padding15">
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        :span-method="arraySpanMethod"
        border
        stripe
        style="width: 100%">
        <el-table-column
          prop="type"
          align="center"
          label="类型">
        </el-table-column>
        <el-table-column
          prop="paramCode"
          align="center"
          label="模板代码">
        </el-table-column>
        <el-table-column
          prop="fileMark"
          align="center"
          label="标识">
        </el-table-column>
        <el-table-column
          prop="description"
          align="center"
          :label="1 == $getInternationalVersionFlag() ? '字段说明(中文)': '字段说明'">
          <template slot-scope="scope">
            <el-button type="text"  @click="linkFiledVoice(scope.row)" >{{scope.row.description}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="descriptionTrans"
          align="center"
          v-if="1 == $getInternationalVersionFlag()"
          label="字段说明（第一语言）">
          <template slot-scope="scope">
            <el-button type="text" @click="linkFiledVoice(scope.row)" >{{scope.row.descriptionTrans}}</el-button>
          </template>
        </el-table-column>
         <el-table-column
          prop="example"
          align="center"
          label="描述">
        </el-table-column>
        <el-table-column
          align="center"
          label="是否自定义">
          <template slot-scope="scope">
            <span>{{scope.row.companyId !== 0 ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fieldType"
          align="center"
          label="字段类型">
          <template slot-scope="scope">
            {{ fieldTypeMap[scope.row.fieldType] || scope.row.fieldType }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="120px">
<!--          v-if="scope.row.companyId !== 0-->
          <template slot-scope="scope"  >
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="editTemplateFiledButton(scope.row)" style="color: #816DF1 !important;"></el-button>
            <el-button type="text" size="medium" icon="el-icon-delete" @click="deleteTemplateFiledButton(scope.row.id)" style="color: #816DF1 !important;"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.currentPage"
          :page-sizes="[50, 100, 200]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalCount">
        </el-pagination>
      </div>
    </div>
    <!-- 添加信息字段 -->
    <el-dialog
      :visible.sync="addTemplateFiled"
      :title="dialogTitle"
      center
      width="63%">
      <div>
        <el-form size="small" label-width="150px" :model="req" :rules="rules" ref="form" >
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="字段说明（中文）" v-if="'1' == $getInternationalVersionFlag()">
                <el-input v-model="req.description" placeholder="请输入10字以内,回车翻译"
                @keyup.enter.native="translateToFirstlanguage"
                clearable/>
              </el-form-item>
              <el-form-item label="字段说明" v-else>
                <el-input v-model="req.description" placeholder="请输入10字以内的状态名称" clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类型">
                <el-select v-model="req.type" style="width: 100%;" placeholder="请选择" filterable>
                  <el-option
                    v-for="item in reqTypeOperate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24" v-if="1 == $getInternationalVersionFlag()">
            <el-col :span="12">
              <el-form-item label="字段说明(第一语言)">
                <el-input v-model="req.descriptionTrans" placeholder="请输入10字以内的状态名称"
                @keyup.enter.native="translateToChinese"
                clearable/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="翻译成中文">
                <el-input v-model="req.descriptionCheck" placeholder="请输入10字以内的状态名称"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="Code码" prop="paramCode">
                <el-input v-model="req.paramCode" :placeholder="inputPlaceNotice" validate-event/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字段标识">
                <el-input v-model="req.fileMark" placeholder='请输入字段标识'/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="描述">
                <el-input v-model="req.example" type="textarea" resize="none" placeholder="请输入状态描述" :rows="4"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="字段类型">
                <el-select v-model="req.fieldType" style="width: 100%;" placeholder="请选择" filterable>
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addTemplateFiled = false" size="small">取 消</el-button>
        <el-button type="primary" @click="add" size="small" plain>保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { debounce } from 'lodash';

export default {
  inject: ['reload'],
  props: {
    changeTabe: {
      type: String
    },
    companySelected: {
    },
    groupSelected: {
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '模板关键字列表') {
        this.getData(1);
      }
    },
    companySelected(companyId) {
      this.companyId = companyId;
      if (this.changeTabe === '模板关键字列表') {
        this.getData(1);
      }
    },
    groupSelected(groupId) {
      this.groupId = groupId;
    }
  },
  data() {
    return {
      rules: {
        paramCode: [
          { validator: this.validateCodeRule, trigger: 'blur' }
        ]
      },
      fieldTypeMap: {
        'string': '字符串类型',
        'number': '数值类型',
        'boolean': '布尔类型'
      },
      options: [{
        value: 'number',
        label: '数值类型'
      }, {
        value: 'string',
        label: '字符串类型'
      }, {
        value: 'boolean',
        label: '布尔类型'
      }],
      value: '',
      loading: true,
      list: [],
      pageData: {},
      sort: {
        order: '',
        sort: ''
      },
      defaultSort: {
        order: 'id',
        sort: 'asc'
      },
      companyId: null,
      groupId: null,
      dialogTitle: null,
      reqTypeOperate: [
        {
          value: '基本信息',
          label: '基本信息'
        },
        {
          value: '金额参数',
          label: '金额参数'
        },
        {
          value: '时间参数',
          label: '时间参数'
        },
        {
          value: '还款信息',
          label: '还款信息'
        },
        {
          value: '公开信息',
          label: '公开信息'
        },
        {
          value: '其他信息',
          label: '其他信息'
        },
        {
          value: '拓展信息',
          label: '拓展信息'
        },
        {
          value: '自定义参数',
          label: '自定义参数'
        },
        {
          value: '逻辑参数',
          label: '逻辑参数'
        },
        {
          value: '字典转译参数',
          label: '字典转译参数'
        },
        {
          value: '联合关键字参数',
          label: '联合关键字参数'
        }
      ],
      typeOperate: [
        {
          value: '基本信息',
          label: '基本信息'
        },
        {
          value: '金额参数',
          label: '金额参数'
        },
        {
          value: '时间参数',
          label: '时间参数'
        },
        {
          value: '还款信息',
          label: '还款信息'
        },
        {
          value: '公开信息',
          label: '公开信息'
        },
        {
          value: '其他信息',
          label: '其他信息'
        },
        {
          value: '拓展信息',
          label: '拓展信息'
        },
        {
          value: '自定义参数',
          label: '自定义参数'
        },
        {
          value: '逻辑参数',
          label: '逻辑参数'
        },
        {
          value: '字典转译参数',
          label: '字典转译参数'
        },
        {
          value: '联合关键字参数',
          label: '联合关键字参数'
        }
      ],
      addTemplateFiled: false,
      req: {
        id: null,
        description: null,
        descriptionTrans: null,
        descriptionCheck: null,
        descriptionOld: null,
        descriptionTransOld: null,
        type: null,
        paramCode: null,
        example: null,
        flag: 1,
        fileMark: null,
        companyId: null,
        fieldType: null
      },
      spanArr: '',
      type: null
    };
  },
  computed: {
    inputPlaceNotice() {
      switch (this.req.type) {
        case '基本信息':
          return '请输入#LBxxxxBL#的代码';
        case '金额参数':
          return '请输入#LBxxxxBL#或#FMxxxxMF#的代码';
        case '时间参数':
          return '请输入#LBxxxxBL#的代码';
        case '还款信息':
          return '请输入#LBxxxxBL#的代码';
        case '公开信息':
          return '请输入#LBxxxxBL#的代码';
        case '其他信息':
          return '请输入20字以内的code代码';
        case '拓展信息':
          return '请输入#LBxxxxBL#的代码';
        case '自定义参数':
          return '请输入#MZDxxxxDZM#的代码';
        case '逻辑参数':
          return '请输入#LGxxxxGL#的代码';
        case '字典转译参数':
          return '请输入#MDZYxxxxYZDM#或#LDZYxxxxYZDL#的代码';
        default:
          return '请输入20字以内的code代码';
      }
    }
  },
  created() {
    // 创建防抖函数，延迟 500ms
    this.debouncedTranslate1 = debounce(this.translateToChinese, 500);
    this.debouncedTranslate2 = debounce(this.translateToFirstlanguage, 500);
  },
  beforeUnmount() {
    // 组件销毁前取消防抖调用
    this.debouncedTranslate1.cancel();
    this.debouncedTranslate2.cancel();
  },
  methods: {
    validateCodeRule(rule, value, callback) {
      if (value && !/^#((LB.*BL)|(LG.*GL)|(FM.*MF)|(MZD.*DZM)|(LDZY.*YZDL)|(MDZY.*YZDM))#$/.test(value)) {
        callback(new Error('Code码输入有误'));
      } else {
        callback();
      }
    },
    getSpanArr(data) {
      this.spanArr = [];
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push([1, 1]);
          this.onepos = 0;
          this.towpos = 0;
        } else if (data[i].type === data[i - 1].type) { // 判断当前元素与上一个元素是否相同
          this.spanArr[this.onepos][0] += 1;
          this.spanArr.push([0, 1]);
          this.towpos = i;
        } else {
          this.spanArr.push([1, 1]);
          this.onepos = i;
          this.towpos = i;
        }
      }
    },
    // 合并
    arraySpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1) {
        const rows = this.spanArr[rowIndex][columnIndex];
        const cols = rows > 0 ? 1 : 0;
        return { rowspan: rows, colspan: cols };
      }
      return { rowspan: 1, colspan: 1 };
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.getData(val);
    },
    add() {
      this.$ajax({
        url: '/template/updateOrInsertFiled',
        prompt: true,
        method: 'POST',
        data: this.req
      }).then(() => {
        this.addTemplateFiled = false;
        this.getData(1);
      });
    },
    addTemplateFiledButton() {
      this.dialogTitle = '添加变量配置';
      this.req.id = null;
      this.req.type = null;
      this.req.paramCode = null;
      this.req.fileMark = null;
      this.req.example = null;
      this.req.description = null;
      this.req.descriptionTrans = null;
      this.req.descriptionCheck = null;
      this.req.descriptionOld = null;
      this.req.descriptionTransOld = null;
      this.req.companyId = this.companyId;
      this.req.fieldType = null;
      this.addTemplateFiled = true;
    },
    editTemplateFiledButton(row) {
      console.warn(row);
      this.dialogTitle = '编辑变量配置';
      this.req.id = row.id;
      this.req.type = row.type;
      this.req.paramCode = row.paramCode;
      this.req.fileMark = row.fileMark;
      this.req.example = row.example;
      this.req.description = row.description;
      this.req.descriptionTrans = row.descriptionTrans;
      this.req.descriptionCheck = null;
      // this.req.descriptionOld = row.description;
      this.req.descriptionOld = null;
      // this.req.descriptionTransOld = row.descriptionTrans;
      this.req.descriptionTransOld = null;
      this.req.companyId = row.companyId;
      this.req.fieldType = row.fieldType;
      this.addTemplateFiled = true;
    },
    deleteTemplateFiledButton(id) {
      this.$confirm('您确定要删除该模板字段吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const h = this.$createElement;
        this.$prompt('', '提示', {
          message: h('p', null, [
            h('span', null, '请输入 '),
            h('i', { style: 'color: red' }, '我确认删除'),
            h('i', null, '后，点击确认进行删除')
          ]),
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /^我确认删除{0,}$/
        }).then(() => {
          this.$ajax({
            prompt: true,
            method: 'DELETE',
            url: `/template/remove/${id}`
          }).then(() => {
            // 刷新
            this.getData();
          });
        });
      });
    },
    getData(page) {
      this.loading = true;
      this.$ajax({
        url: '/template/getFiledList',
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        this.list = res.data.list;
        this.getSpanArr(this.list);
        this.pageData.pageSize = res.data.limit;
        this.pageData.totalCount = res.data.totalRecords;
        this.pageData.currentPage = res.data.currentPage;
        this.loading = false;
      });
    },
    getSearchParam(page) {
      const req = {
        'companyId': this.companyId,
        'type': this.type,
        'page': page,
        'limit': this.pageData.pageSize || 50,
        'order': this.sort.order || this.defaultSort.order,
        'sort': this.sort.sort || this.defaultSort.sort
      };
      return req;
    },
    linkFiledVoice(row) {
      console.warn(row);
      sessionStorage.setItem('filedId', row.id);
      this.$emit('showbox', '关键字音频');
    },
    translateToFirstlanguage() {
      if (this.req.description === null || this.req.description === isNaN || this.req.description === '') {
        this.req.descriptionTrans = null;
        this.req.descriptionOld = null;
        return;
      }
      if (!(this.req.descriptionTrans === null || this.req.descriptionTrans === isNaN || this.req.descriptionTrans === '') && this.req.description === this.req.descriptionOld) {
        return;
      }
      const param = {
        originData: this.req.description,
        from: '中文',
        to: this.getFirstLanguage()
      };
      // 调用翻译接口
      this.$ajax({
        url: '/workflow/translation',
        method: 'POST',
        data: param
      }).then((res) => {
        if (res.data !== null) {
          this.req.descriptionTrans = res.data;
          this.req.descriptionOld = this.req.description;
        }
      }).catch(() => {
        this.$message({
          message: '翻译失败，请稍后重试',
          type: 'error'
        });
      });
    },
    translateToChinese() {
      if (this.req.descriptionTrans === null || this.req.descriptionTrans === isNaN || this.req.descriptionTrans === '') {
        this.req.descriptionTransOld = null;
        return;
      }
      if (!(this.req.descriptionCheck === null || this.req.descriptionCheck === isNaN || this.req.descriptionCheck === '') && this.req.descriptionTrans === this.req.descriptionTransOld) {
        return;
      }
      const param = {
        originData: this.req.descriptionTrans,
        from: this.getFirstLanguage(),
        to: '中文'
      };
      // 调用翻译接口
      this.$ajax({
        url: '/workflow/translation',
        method: 'POST',
        data: param
      }).then((res) => {
        if (res.data !== null) {
          this.req.descriptionCheck = res.data;
          this.req.descriptionTransOld = this.req.descriptionTrans;
        }
      }).catch(() => {
        this.$message({
          message: '翻译失败，请稍后重试',
          type: 'error'
        });
      });
    },
    getFirstLanguage() {
      const languageSelectOptions = this.$getLanguageSelectOptions();
      let firstLanguage = '';
      // 从languageSelectOptions中获取第一语言
      if (languageSelectOptions && languageSelectOptions.length > 0) {
        const nonZeroLang = languageSelectOptions.find(item => item.modelCode !== '0');
        if (nonZeroLang) {
          firstLanguage = nonZeroLang.modelName;
        }
      }
      return firstLanguage;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/engine/template_filed.vue